import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { CREATE_PROSPECTION_SITE } from "../created-site.queries";
import {
  CreateProspectionSiteMutation,
  CreateProspectionSiteMutationVariables,
} from "../../../__generated__/CreateProspectionSiteMutation";

export const useCreateProspectionSite = () => {
  const [mutate, { loading }] = useMutation<
    CreateProspectionSiteMutation,
    CreateProspectionSiteMutationVariables
  >(CREATE_PROSPECTION_SITE, {
    refetchQueries: ["CustomerQuery", "CreatedSitesQuery"],
  });

  const createProspectionSite = async (
    variables: CreateProspectionSiteMutationVariables
  ): Promise<number | null> => {
    if (loading) return null;
    try {
      const { data } = await mutate({ variables });
      if (data?.createProspectionSite?.ok) {
        toast.success("La génération du site de prospection a été lancée");
        return data.createProspectionSite.createdSiteId ?? null;
      }
      toast.error(data?.createProspectionSite?.error ?? "Une erreur est survenue");
      return null;
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
      return null;
    }
  };

  return { createProspectionSite, loading };
};
